import request from '../request'
import { Pass_Knowledge_Url } from '../../conf'

export interface SigninRequest {
    username: string
    password: string
}

/**
 * 登录
 * @param {SigninRequest} data
 */
export const signin = async <T>(data: SigninRequest): Promise<T> => {
    const url = '/wulai/store/user/login'
    return request.post(url, data)
}

interface SiginupRequest {
    username: string
    password: string
    nickname: string
}
export const signup = async (data: SiginupRequest) => {
    const url = '/wulai/store/user/register'
    const env = process.env.NODE_ENV
    if (env === 'development') {
        return request.post(url, data, {
            headers: {
                Authorization: 'Basic d3VsYWk6WEZSUkU4cVZ3Mmk5M2hXdw==',
            },
        })
    }
    return request.post(url, data)
}
interface GetStaffInfoResponse {
    staff_id: string
    apps: {
        app_name: string
        app_hash: string
    }[]
}
/**
 * 获取员工信息
 */
export const getStaffInfo = async (): Promise<{
    data: { staff: GetStaffInfoResponse }
}> => {
    const query = `
        query GetStaffInfo($staffId: Int) {
            staff(staff_id: $staffId) {
                staff_id
                apps {
                    app_name
                    app_hash
                }
            }

        }
    `
    const variables = {
        menuType: 1,
    }
    const operationName = 'GetStaffInfo'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

interface GetAppInfoResponse {
    data: {
        getAppInfo: {
            app_name: string
            app_hash: string
            root_tag_id: string
        }
    }
}
export const getAppInfo = async (
    appHash: string
): Promise<GetAppInfoResponse> => {
    const query = `
        query GetAppInfo($appHash: String!) {
            getAppInfo(app_hash: $appHash, forceReadDb: true) {
                app_name
                app_hash
                root_tag_id
            }
        }
    `
    const variables = {
        appHash,
    }
    const operationName = 'GetAppInfo'
    return request.post(Pass_Knowledge_Url, {
        query,
        variables,
        operationName,
    })
}

export const changePassword = (oldPassword: string, newPassword: string) => {
    const url = '/wulai/store/user/change_password'
    return request.post(url, {
        old_password: oldPassword,
        new_password: newPassword,
    })
}

interface codeMessage {
    code: number
    message?: string
}
// 验证手机号是否存在
export const checkPhone = (data: object) => {
    // const url = '/wulai/store/user/login'
    // return request.post(url, data)
    return {
        code: '200',
    }
}

// 获取验证码
export const getCodeValue = (data: object): Promise<codeMessage> => {
    const url = '/wulai/store/user/forget_pwd/send_code'
    return request.post(url, data)
}

interface pswMessage {
    status_code: number
    message?: string
}
// 修改密码
export const changePsw = (data: object): Promise<pswMessage> => {
    const url = '/wulai/store/user/forget_pwd/reset_pwd'
    return request.post(url, data)
}
